"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { newObj[key] = obj[key]; } } } newObj.default = obj; return newObj; } }

var _I6T3D36Kcjs = require('./I6T3D36K.cjs');


var _O7FALLU5cjs = require('./O7FALLU5.cjs');



var _MLKK6UGOcjs = require('./MLKK6UGO.cjs');



var _FH6HQ5JNcjs = require('./FH6HQ5JN.cjs');


var _3BSDKDKDcjs = require('./3BSDKDKD.cjs');

// src/combobox/combobox-store.ts
var _comboboxstore = require('@ariakit/core/combobox/combobox-store'); var Core = _interopRequireWildcard(_comboboxstore);
function useComboboxStoreOptions(props) {
  const tag = _I6T3D36Kcjs.useTagContext.call(void 0, );
  props = {
    ...props,
    tag: props.tag !== void 0 ? props.tag : tag
  };
  return _MLKK6UGOcjs.useCompositeStoreOptions.call(void 0, props);
}
function useComboboxStoreProps(store, update, props) {
  _3BSDKDKDcjs.useUpdateEffect.call(void 0, update, [props.tag]);
  _FH6HQ5JNcjs.useStoreProps.call(void 0, store, props, "value", "setValue");
  _FH6HQ5JNcjs.useStoreProps.call(void 0, store, props, "selectedValue", "setSelectedValue");
  _FH6HQ5JNcjs.useStoreProps.call(void 0, store, props, "resetValueOnHide");
  _FH6HQ5JNcjs.useStoreProps.call(void 0, store, props, "resetValueOnSelect");
  return Object.assign(
    _MLKK6UGOcjs.useCompositeStoreProps.call(void 0, 
      _O7FALLU5cjs.usePopoverStoreProps.call(void 0, store, update, props),
      update,
      props
    ),
    { tag: props.tag }
  );
}
function useComboboxStore(props = {}) {
  props = useComboboxStoreOptions(props);
  const [store, update] = _FH6HQ5JNcjs.useStore.call(void 0, Core.createComboboxStore, props);
  return useComboboxStoreProps(store, update, props);
}





exports.useComboboxStoreOptions = useComboboxStoreOptions; exports.useComboboxStoreProps = useComboboxStoreProps; exports.useComboboxStore = useComboboxStore;
